<template>
  <div>

    <div class="control is-grouped">
      <p class="control">
        <a v-if="canCreate(permissionKey)" href="#/users/new" class="button is-success">
        <span class="icon">
          <i class="fa fa-plus-circle"></i>
        </span>
          <span>Создать пользователя</span>
        </a>
      </p>
      <p v-if="canSelectUser(permissionKey)" class="control">
        <a href="#" class="button is-success" v-on:click="addUserByIdToMain">
                <span class="icon">
                  <i class="fa fa-plus-circle"></i>
                </span>
          <span>Подобрать пользователя по идентификатору</span>
        </a>
      </p>
      <p v-if="canSelectUser(permissionKey)" class="control is-expanded">
        <input v-model="dependedUserId" class="input" type="text" placeholder="Идентификатор">
      </p>
    </div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th @click="sort('username')">E-mail{{sortIcon('username')}}</th>
                <th @click="sort('id')">Идентификатор{{sortIcon('id')}}</th>
                <th @click="sort('roleString')">Роль{{sortIcon('roleString')}}</th>
                <th @click="sort('state')">Статус{{sortIcon('state')}}</th>
              </tr>
              </thead>
              <thead>
              <tr v-for="user in sortedUsers">
                <td>
                  <a :href="'#/users/'+user.id">{{user.username}}</a>
                </td>
                <td>
                  {{user.id}}
                </td>
                <td>
                  {{user.roleString}}
                </td>
                <td>
                  {{user.state}}
                </td>
              </tr>
              </thead>
            </table>
          </div>
          <div id="page-navigation">
          <ul class="pagination">
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickFirstPage"
                :disabled="isInFirstPage"
                aria-label="Go to first page"
              >
                Первая
              </button>
            </li>
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickPreviousPage"
                :disabled="isInFirstPage"
                aria-label="Go to previous page"
              >
                Предыдущая
              </button>
            </li>
            <li v-for="page in pages" class="pagination-item">
              <button
                type="button"
                @click="onClickPage(page.name)"
                :disabled="page.isDisabled"
                :class="{ activepage: isPageActive(page.name) }"
                :aria-label="`Go to page number ${page.name}`"
              >
                {{ page.name }}
              </button>
            </li>
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickNextPage"
                :disabled="isInLastPage"
                aria-label="Go to next page"
              >
                Следующая
              </button>
            </li>
            <li class="pagination-item">
              <button
                type="button"
                @click="onClickLastPage"
                :disabled="isInLastPage"
                aria-label="Go to last page"
              >
                Последняя
              </button>
            </li>
          </ul>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  import Vue from 'vue'
  import Notification from 'vue-bulma-notification'
  import CheckToken from '../authentication/CheckToken'
  import CheckPermission from '../authentication/CheckPermission'

  Vue.mixin(CheckToken)
  Vue.mixin(CheckPermission)

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4600,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const USERS_API = '/api/users'

  export default {
    components: {
      Notification
    },
    data () {
      return {
        users: [],
        sortedUsers: [],
        currentPage: 1,
        perPage: 10,
        maxVisibleButtons: 10,
        currentSort: 'username',
        currentSortDir: 'asc',
        ascIcon: ' ▲',
        descIcon: ' ▼',
        dependedUserId: null,
        permissionKey: 'user'
      }
    },
    created: function () {
      this.checkToken()
      this.loadData()
    },
    computed: {
      ...mapGetters([
        'authenticationToken',
        'loggedId'
      ]),
      totalPages() {
        return Math.max(Math.ceil(this.users.length / this.perPage), 1)
      },
      startPage() {
        if (this.currentPage === 1) {
          return 1
        }

        if (this.currentPage === this.totalPages) {
          return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1)
        }

        return this.currentPage - 1
      },
      endPage() {
        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
      },
      pages() {
        const range = []
        for (let i = this.startPage; i <= this.endPage; i += 1) {
          range.push({
            name: i,
            isDisabled: i === this.currentPage
          })
        }
        return range
      },
      isInFirstPage() {
        return this.currentPage === 1
      },
      isInLastPage() {
        return this.currentPage === this.totalPages
      }
    },

    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadApplications () {
          this.loadData()
      },
      loadData () {
        this.$http.get(USERS_API, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.users = response.data
            this.sortedUsers = this.sortedUser()
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки списка пользователей. ')
          })
      },
      addUserByIdToMain () {
            if (this.dependedUserId) {
              this.$http.post(USERS_API + '/addToMain', this.prepareRequest(this.dependedUserId), {headers: this.prepareSecurityHeader()})
                .then((response) => {
                  if (response.status == 200) {
                    this.openNotificationWithType('success', 'Клиент добавлен')
                    this.users = this.loadData()
                    this.dependedUserId = null
                  } else {
                    this.openNotificationWithType('warning', 'Невозможно добавить клиента')
                  }
                })
                .catch((error) => {
                  this.openNotificationWithType('danger', 'Ошибка добавления клиента')
                  console.log(error)
                })
            } else {
              this.openNotificationWithType('danger', 'Укажите ID клиента')
            }
      },
      prepareRequest (userId) {
        const formData = new FormData()
        formData.append('id', userId)
        return formData
      },
      sortedUser() {
        return this.users.sort((a, b) => {
          let modifier = 1
          if (this.currentSortDir === 'desc') modifier = -1
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
          return 0
        }).filter((row, index) => {
          let start = (this.currentPage - 1) * this.perPage
          let end = this.currentPage * this.perPage
          if (index >= start && index < end) return true
        })
      },
      sort(s) {
        // if s == current sort, reverse
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
        }
        this.currentSort = s
        this.sortedUsers = this.sortedUser()
      },
      sortIcon(s) {
        if (s === this.currentSort) {
          if (this.currentSortDir === 'asc') {
            return this.ascIcon
          } else {
            return this.descIcon
          }
        } else {
          return ''
        }
      },
      onClickFirstPage() {
        this.onPageChange(1)
      },
      onClickPreviousPage() {
        this.onPageChange(this.currentPage - 1)
      },
      onClickPage(page) {
        this.onPageChange(page)
      },
      onClickNextPage() {
        this.onPageChange(this.currentPage + 1)
      },
      onClickLastPage() {
        this.onPageChange(this.totalPages)
      },
      isPageActive(page) {
        return this.currentPage === page
      },
      onPageChange(page) {
        this.currentPage = page
        this.sortedUsers = this.sortedUser()
      },
      viewBilling (id) {
        this.$router.push('/billing/client/' + id)
      },
      viewProfile (id) {
        this.$router.push('/profiles/' + id)
      },
      openNotificationWithType (type, message) {
        openNotification({
          title: 'Уведомление',
          message: message,
          type: type
        })
      }
    }
  }
</script>

<style lang="scss">

  .pagination {
    list-style-type: none;
  }

  .pagination-item {
    display: inline-block;
  }

  .activepage {
    background-color: #4AAE9B;
    color: #ffffff;
  }

  .table > thead > tr > th {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// Users.vue?7872063e